// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__O008B","loaderOuter":"PageOverlayLoader_loaderOuter__3Er5a"};